import React from 'react'
import Moment from 'moment'

const SnoozeToast = ({history, person}) => (
  <div>
    snoozed until
    {' '}
    <div className="toast-button" onClick={() => history.push(`/chooseSnoozeDate/${person.id}`)}>
      {Moment(person.nextTouch).format('MMM Do')}
    </div>
  </div>
)

export default SnoozeToast



// WEBPACK FOOTER //
// ./src/views/person/SnoozeToast.js